import React, { useState, useRef, useEffect } from "react";

export const About = (props) => {
  const aboutRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (aboutRef.current) {
        const rect = aboutRef.current.getBoundingClientRect();

        // Điều chỉnh điều kiện để phát hiện phần tử nằm trong viewport
        if (rect && rect.top <= 300) {
          setIsActive(true);
        } else {
          setIsActive(false);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div id="about" ref={aboutRef}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-12">
            <div className="about-text">
              <h2>About Us</h2>
              {/* DOM order is always image -> text, and the alternating side comes
                  from CSS. Branching the markup on window width would bake the
                  prerender's narrow-viewport order into the static HTML and mismatch
                  on hydration. */}
              {props.data
                ? props.data.content.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className={`row content ${i % 2 === 0 ? 'content--image-right' : 'content--image-left'}`}
                  >
                    <div className="col-sm-12 col-md-6">
                      <img src={d.image} className={`img-responsive ${isActive ? 'about-active' : ''}`} alt={d.title || "Pandobit"} loading="lazy" decoding="async" />
                    </div>
                    <div className={`col-sm-12 col-md-6 content-text ${isActive ? 'about-active' : ''}`}>
                      <h3>{d.title}</h3>
                      {d.paragraph.map((p, pi) => (
                        <p key={pi}>{p}</p>
                      ))}
                    </div>
                  </div>
                ))
                : "loading"}
              <div className="row footer">
                {props.data
                  ? props.data.footer.map((p, i) => (
                    <div key={`${p.title}-${i}`} className="col-xs-12 col-md-4">
                      <h3><i className="fa fa-check"></i>{p.title}</h3>
                      <p>{p.paragraph}</p>
                    </div>
                  )
                  )
                  : "loading"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
